export class PhoneObject {
  name: string;
  phoneNumber: string;
  appointment: string;
}
